import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { CheckboxTableRow, ExTable, SelectionFixedFooter, TableBody, TableHead, TableWrapper, useMultipleCheckForm } from 'components/shared/widget'
import { useDownloadCsvPatientsApi, useFetchPatientsApi } from 'api/patient'
import { Patient, PatientSearchForm } from 'entities/patient'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { patientColumnInfoList, PatientTableData } from './patient_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { InputField } from 'components/shared/input'
import { useState } from 'react'
import { EditPatientForm } from './patient_form'
import { Flex } from 'components/shared/flex'

type Props = {
    history: H.History
}

const PatientsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<PatientSearchForm>()
    const preSearchForm = useForm<PatientSearchForm>(params)
    const searchForm = useForm<PatientSearchForm>({ ...params })
    const api = useFetchPatientsApi(searchForm)
    const downloadCsvApi = useDownloadCsvPatientsApi(searchForm)
    const checkIdForm = useMultipleCheckForm<Patient>()
    const patientDisplaySetting = useDisplaySetting(patientColumnInfoList(searchForm), 'Patient')
    const [selectedPatient, setSelectedPatient] = useState<Patient>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof PatientSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`patients?${queryParams}`)
        }
    }, [searchForm.object])

    const handleClickEdit = (patient: Patient) => {
        setSelectedPatient(patient)
        setShowEdit(true)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(downloadCsvApi.loading)
    }, [downloadCsvApi.loading])

    return (
        <>
            <EditPatientForm
                patient={selectedPatient}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ContentHeader
                headerTitle="ユーザー"
                left={
                    <>
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                    <InputField
                        attr="name"
                        form={preSearchForm}
                        placeholder="名前で検索"
                        onPressEnter={() => {
                            searchForm.updateObject('name', preSearchForm.getValue('name'))
                        }}
                        style={{ marginBottom: 0, width: 250 }}
                    />
                </Flex>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={checkIdForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={checkIdForm} showEdit>
                                {/* <ActionTableCell th width={60} /> */}
                                <TableHeads displaySetting={patientDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={patientDisplaySetting.getColumnLength() + 1}>
                            {api.response.results.map((patient: Patient) => {
                                return (
                                    <CheckboxTableRow
                                        key={`patient-${patient.id}`}
                                        item={patient}
                                        multipleCheckForm={checkIdForm}
                                        onClickEdit={() => handleClickEdit(patient)}
                                    >
                                        <PatientTableData patient={patient} displaySetting={patientDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={checkIdForm.ids()}
                onClickReset={() => checkIdForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="Patient"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(PatientsPage)
